export function nextRandom(state: number): [number, number] {
  let value = state | 0;
  value ^= value << 13;
  value ^= value >>> 17;
  value ^= value << 5;
  const next = value >>> 0;
  return [next, next / 4_294_967_296];
}

export function randomRange(state: number, minimum: number, maximum: number): [number, number] {
  const [next, value] = nextRandom(state);
  return [next, minimum + (maximum - minimum) * value];
}
